import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { useAuthentication } from '@features/auth/useAuthentication.ts';
import { isNullOrUndefined } from '@utils/nulls.ts';
import { withQuery } from '@utils/withQuery.ts';
import { useNavigate } from 'react-router';
import { useParams } from '@router.ts';
import { useCurrentSalonStore } from '@stores/useCurrentSalonStore.ts';

type AuthenticationProps = {};

const AuthenticationNeeded: React.FC<PropsWithChildren<AuthenticationProps>> = ({ children }) => {
  const { checkAuthentication, authenticationDone, loggedUser } = useAuthentication();
  const navigate = useNavigate();
  const hasChecked = useRef(false);
  const { entityId } = useParams('/app/:entityId');
  const { setCurrentSalonId, currentSalon } = useCurrentSalonStore();

  console.log(loggedUser, currentSalon);

  useEffect(() => {
    if (!hasChecked.current) {
      hasChecked.current = true;
      checkAuthentication();
    }
  }, [checkAuthentication]);

  useEffect(() => {
    if (authenticationDone && isNullOrUndefined(loggedUser)) {
      navigate({ pathname: withQuery('/login') });
    }
    if (authenticationDone && loggedUser && entityId) {
      setCurrentSalonId(entityId);
    }
  }, [authenticationDone, loggedUser, navigate]);

  return <>{children}</>;
};

export default AuthenticationNeeded;
